// import { RootState } from "~store/store";
import { RootState } from "../../store";
export const historiesSelector = (state: RootState) => {
  return state.histories;
};
